import { Link } from "react-router-dom";
import { contactInfo, footerGroups, friendlyLinks, siteInfo } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2 flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-accent-500 text-background-50">
                <i className="ri-compass-3-line text-xl" />
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-primary-200">
              {siteInfo.intro}
            </p>
            <div className="flex flex-col gap-2 text-sm text-primary-200">
              <span className="flex items-center gap-2">
                <i className="ri-phone-line text-base" />
                {contactInfo.phone}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-base" />
                {contactInfo.email}
              </span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="flex flex-col gap-4">
              <h3 className="font-heading text-sm font-semibold text-background-50">
                {group.title}
              </h3>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-200 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-primary-800 pt-6">
          <p className="text-xs text-primary-300 mb-3">友情链接</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {friendlyLinks.map((item) => (
              <span key={item} className="text-sm text-primary-200">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800 px-4 md:px-8 py-5">
        <div className="flex flex-col gap-3 sm:flex-row items-center justify-between">
          <p className="text-xs text-primary-300">{siteInfo.copyright}</p>
          <p className="text-xs text-primary-300">
            本站为品牌展示平台，部分下载与提交功能为前端演示
          </p>
        </div>
      </div>
    </footer>
  );
}